import * as React from "react"
import { Skeleton } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { AppTableSeeker } from "@components"

import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import useUserActivityTable from "../../@hooks/useTable"
import { dashboardColumn, sectionColumn, dateColumn, submitsColumn, userColumn, customerColumn, countryColumn } from "./columns"
import {appliedCustomerIDs} from "../../@signals";


export default function UserActivityTable() {
	const {tableData, isLoadingTable} = useUserActivityTable()
	const { showToast } = useToast()

	if (isLoadingTable) return <Skeleton variant="rectangular" height={500} />
	if (!tableData.length) return <></>

	const columns = [
        dateColumn(),
        countryColumn(),
        userColumn(),
        ...appliedCustomerIDs.value.length !== 1 ? [customerColumn()] : [],
        sectionColumn(),
		dashboardColumn(),
        submitsColumn()
	]

	return <AppTableSeeker
		data={tableData}
		title={<><IconSeeker icon="tachometer" iconWeight='thin' /> Activity Logs</>}
		columns={columns}
		options={{
			tableBodyHeight: '500',
			onDownload: () => showToast.promiseExcel(`${BACKEND_APIS.ADMIN}/user-activities/details/excel`)
		}}
	/>
}